import {FC, useState, createContext, useContext} from 'react'
import { OperatorRootUpdate } from './_models'

const ListViewContext = createContext<{itemIdForUpdate?: OperatorRootUpdate, setItemIdForUpdate?: any}>({})

const ListViewProvider: FC = ({children}) => {
  const [itemIdForUpdate, setItemIdForUpdate] = useState<OperatorRootUpdate>()

  return (
    <ListViewContext.Provider
      value={{
        itemIdForUpdate,
        setItemIdForUpdate,
      }}
    >
      {children}
    </ListViewContext.Provider>
  )
}

const useListView = () => useContext(ListViewContext)

export {ListViewProvider, useListView}

